import { APICallV1 } from 'reactApp/api/APICall';

export class ExtraEmailConfirmAPICall extends APICallV1 {
    _method = 'profile/confirm_email';
    _type = 'post';
    defaultData = this._defaultPayload;
}
